const vrMessage = () => {
	
	$(document).ready(function () {
		var body = $('body');
		
		var message = $('#js-vr-message');
		var stores = $('#js-stores');
		if (stores.length == 1 && message.length == 1) {
			var storesPosition = stores.offset();
			var fix = $(window).height() / 2;
			var closers = $('.js-vr-message-closer');
			
			$('#js-saloon-map').click(function (e) {
				if (!body.hasClass('vr-message-showed')) {
					message.addClass('active');
					body.addClass('vr-message-showed');
				}
			});
			// $(window).scroll(function () {
			// 	if (!body.hasClass('vr-message-showed')) {
			// 		var scroll = window.pageYOffset;
			// 		if (scroll + fix >= storesPosition.top) {
			// 			message.addClass('active');
			// 			body.addClass('vr-message-showed');
			// 		}
			// 	}
			// });
			
			closers.each(function () {
				let closer = $(this);
				closer.click(function (e) {
					e.preventDefault();
					message.removeClass('active');
				})
			})
		}
	});
}

export {vrMessage}


// WEBPACK FOOTER //
// ../components/vrMessage/vrMessage.js